var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"iconfont",class:_vm.name,style:(Object.assign(_vm.cstyle,{
    fontSize:_vm.size + 'px',
    color: _vm.color
  }))})])}
var staticRenderFns = []

export { render, staticRenderFns }